import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import Error404 from 'components/errors/404'
import Logo from 'components/logo'
import { imagePath } from 'utils/image'
import Metatags from 'components/metatags/metatags'
import { formatDateTimeTimezone } from 'utils/date'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { PageContent } from 'components/styled/page/page-content'
import { PageHeader } from 'components/page-header'
import { MediumHeaderContent } from 'components/page-header/medium-header-content'
import { Box } from 'components/styled/containers/box'

/**
 * Render container for the page
 */

const propTypes = {
  jobOpening: PropTypes.shape({
    title: PropTypes.string,
    endTime: PropTypes.string,
    location: PropTypes.string,
    photo: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    logo: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    company: PropTypes.shape({
      privacyPolicy: PropTypes.string,
    }),
  }).isRequired,
  personalInterview: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  i18n: PropTypes.shape({
    layout: PropTypes.shape({
      endTime: PropTypes.func,
    }),
  }).isRequired,
  httpError: PropTypes.number,
  size: PropTypes.string,
  hideLogo: PropTypes.bool,
}

const defaultProps = {
  children: undefined,
  httpError: undefined,
  personalInterview: undefined,
  size: 'medium',
  hideLogo: false,
}

const mapStateToProps = (state, ownProps) => ({
  jobOpening: ownProps.jobOpening || state.interview.jobOpening,
  httpError: state.global.httpError,
  personalInterview: state.interview.personalInterview,
})
export function Layout(props) {
  const {
    jobOpening,
    personalInterview,
    children,
    i18n,
    httpError,
    hideLogo,
    size,
  } = props

  const opening = jobOpening.title
    ? jobOpening
    : get(personalInterview, 'position.item', {})

  const location = opening.location || ''
  const endTime = opening.endTime
    ? i18n.layout.endTime(formatDateTimeTimezone(opening.endTime))
    : ''

  return (
    <>
      {httpError === 404 ? (
        <Error404 />
      ) : (
        <div>
          <PageHeader photo={imagePath(opening.photo)}>
            <MediumHeaderContent
              title={opening.title}
              description={location}
              status={endTime}
            />
          </PageHeader>
          {opening.logo && !hideLogo && (
            <Box mt="s32">
              <Logo logo={imagePath(opening.logo)} />
            </Box>
          )}
          <Metatags title={opening.title} />
          <PageContent size={size} mt="s32">
            {children}
          </PageContent>
        </div>
      )}
    </>
  )
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(Layout)
